import React from 'react';
// import './ClassifyCamAIHeader.css';

const ClassifyCamAIHeader = () => (
  <div className="product-header-block sub-classifycam">
    <div className="product-header-content">
      <span className="badge-edge">Low-Power Edge DSP</span>
      <h2>ClassifyCamAI</h2>
      <p>Turning Mobile Devices into Autonomous Acoustic Sensors</p>
    </div>
  </div>
);

export default ClassifyCamAIHeader;
